import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useState } from 'react';

import CheckoutCardForm from '@/components/Profile/Billing/CheckoutCardForm';
import { useClientSecretSetupIntent } from '@/Utils/stripeHooks/useSavePayMethod';

const AddPaymentMethod = ({
  stripeKey,
  handleToggleModal,
  handleSelectedPayment,
}: {
  stripeKey: string;
  handleToggleModal: () => void;
  handleSelectedPayment: (id: string) => void;
}) => {
  const { data: clientSecretSetupIntent } = useClientSecretSetupIntent();

  const stripePromise = loadStripe(stripeKey);
  const options = { clientSecret: clientSecretSetupIntent };

  return (
    <div className='flex flex-col gap-12 overflow-y-scroll h-max-content '>
      <h2
        style={{
          fontFamily: 'Sintony',
          letterSpacing: '-1px',
        }}
        className='font-bold text-18px'
      >
        Add a Payment Method
      </h2>
      <p style={{ color: 'rgba(0, 0, 0, 0.87)', lineHeight: '24px' }}>
        Choose a payment method (credit/debit card or bank transfer) and enter
        the details below to save it for future purchases.
      </p>
      {clientSecretSetupIntent && (
        <Elements
          stripe={stripePromise}
          options={{
            ...options,
            appearance: {
              rules: {
                '.p-Tab': {
                  marginLeft: '2px',
                  marginRight: '2px',
                },
              },
            },
          }}
        >
          <CheckoutCardForm
            handleToggleModal={handleToggleModal}
            handleSelectedPayment={handleSelectedPayment}
          />
        </Elements>
      )}
    </div>
  );
};

export default AddPaymentMethod;
